import { useEffect } from "react"
import { Routes, Route } from "react-router-dom"
import { connect, useDispatch } from "react-redux"
import CssBaseline from "@mui/material/CssBaseline"
import { SnackbarProvider } from "notistack"

// Import Routes all - Using MUI versions
import { authProtectedRoutes, publicRoutes, SinglePageRoutes } from "./routes/mui-routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format - New MUI Layout
import { MainLayout } from "./layouts"
import NonAuthLayout from "./components/NonAuthLayout"
import { getCustomers as onGetCustomers } from "store/actions"
import { fetchCompanyDetails } from "store/company/actions"
import { setUserPermissions } from "store/auth/login/actions"

// Theme Context Provider
import { ThemeContextProvider } from "./theme/ThemeContext"

// App Config Context Provider
import { AppConfigProvider } from "./context/AppConfigContext"

// Keep SCSS for now during migration (will be removed after full MUI migration)
import "./assets/scss/theme.scss"

const App = props => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(onGetCustomers())
    dispatch(fetchCompanyDetails())

    // Initialize user permissions from localStorage on app load
    const authUser = localStorage.getItem("authUser")
    if (authUser) {
      try {
        const user = JSON.parse(authUser)
        if (user && user.session_token) {
          dispatch(setUserPermissions(user, user.permissions || {}, user.groups || [], user.enabled_modules || {}))
        }
      } catch (e) {
        console.error("Error parsing authUser from localStorage:", e)
      }
    }
  }, [dispatch])

  // Use new MUI MainLayout for all authenticated routes
  const Layout = MainLayout

  return (
    <ThemeContextProvider>
      <AppConfigProvider>
        <CssBaseline />
        <SnackbarProvider
        maxSnack={3}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={3000}
      >
        <Routes>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              key={idx}
              element={
                <Authmiddleware
                  layout={NonAuthLayout}
                  component={route.component}
                  isAuthProtected={false}
                />
              }
            />
          ))}

          {SinglePageRoutes.map((route, idx) => (
            <Route
              path={route.path}
              key={idx}
              element={
                <Authmiddleware
                  layout={NonAuthLayout}
                  component={route.component}
                  isAuthProtected={true}
                />
              }
            />
          ))}

          {authProtectedRoutes.map((route, idx) => (
            <Route
              path={route.path}
              key={idx}
              element={
                <Authmiddleware
                  layout={Layout}
                  component={route.component}
                  isAuthProtected={true}
                />
              }
            />
          ))}
        </Routes>
        </SnackbarProvider>
      </AppConfigProvider>
    </ThemeContextProvider>
  )
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
